module.exports = __webpack_public_path__ + "static/media/nx.d39770e9.hdr";